import { useState, useEffect } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import Checkbox from "components/Checkbox/Checkbox"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const Cell = ({ arm, intervention, onChange, tableData, isDisabled, prevArmLengthRef, arms, interventions }) => {
  const { readOnly, showPagePreview } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      showPagePreview: state.showPagePreview,
    }))
  )

  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (isDisabled === false) {
      if (prevArmLengthRef.current === 1) {
        onCheck(false)
        setTimeout(() => {
          prevArmLengthRef.current = arms.length
        }, 400)
      }
    }
  }, [isDisabled])

  useEffect(() => {
    if (arms.length === 1) {
      onCheck(true)
    }
  }, [arms, interventions])

  useEffect(() => {
    let isChecked = false

    let foundIntervention = tableData?.interventions?.find((item) => item.id === intervention.id)
    if (foundIntervention?.arms) {
      isChecked = foundIntervention.arms.some((armId) => armId === arm.id)
    }

    setChecked(isChecked)
  }, [])

  const onCheck = (val) => {
    setChecked(val)
    onChange(val, arm, intervention)
  }

  return (
    <td
      key={intervention.id + arm.id}
      style={{
        verticalAlign: "middle",
      }}
    >
      <Checkbox
        id={arm.id + intervention.id}
        disabled={readOnly || showPagePreview || isDisabled}
        onChange={(e) => onCheck(e.target.checked)}
        checked={checked}
      />
    </td>
  )
}

export default Cell
